import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, TooltipContainer, TooltipSelect } from '@luigiclaudio/ga-baseline-ui/tooltip';
import ColorTooltipSelectionAction from './ColorTooltipSelectionAction';

const ColorTooltip = ({ colorValue, closeOnScroll, children }) => {
    return (
        <Tooltip detect="click" minWidth={140} offset={10} closeOnScroll={closeOnScroll}>
            <TooltipSelect>
                <ColorTooltipSelectionAction
                    skin="muted"
                    disabled={!colorValue}
                    colorValue={colorValue}
                />
            </TooltipSelect>
            <TooltipContainer isFullWidth>{children}</TooltipContainer>
        </Tooltip>
    );
};

ColorTooltip.propTypes = {
    children: PropTypes.node.isRequired,
    colorValue: PropTypes.string,
    closeOnScroll: PropTypes.bool,
};

ColorTooltip.defaultProps = {
    colorValue: undefined,
    closeOnScroll: false,
};

export default ColorTooltip;
